import platform from "platform";

/**
 * Device fingerprint sent with signin / signup / complete-signin.
 *
 * This was previously copy-pasted verbatim into Login, SignUp, TwoFA and
 * AuthApp2Fa — keep it here so the payload can never drift between them.
 */
export type DeviceInfo = {
  name: string;
  uniqueId: string;
  os: string | undefined;
};

const getBrowserName = (userAgent: string): string => {
  // Order matters: Edge and Chrome both contain "Chrome" / "Safari".
  if (userAgent.includes("Firefox")) return "Mozilla Firefox";
  if (userAgent.includes("Edg")) return "Microsoft Edge";
  if (userAgent.includes("Chrome")) return "Google Chrome";
  if (userAgent.includes("Safari")) return "Apple Safari";
  if (userAgent.includes("MSIE") || userAgent.includes("Trident/"))
    return "Internet Explorer";
  return "Unknown Browser";
};

export const getDeviceInfo = (): DeviceInfo => ({
  name: getBrowserName(navigator.userAgent),
  // Pseudo-unique: user agent plus screen dimensions.
  uniqueId: `${navigator.userAgent}-${window.screen.width}x${window.screen.height}`,
  os: platform.os?.family,
});
